export default __webpack_public_path__ + "static/logo-217ed7a8a2a88151309d8113c9b4d6c6.png";